import React from 'react';

import classes from './ProductSidebars.scss';

export const ProductSidebar: React.FC<React.PropsWithChildren> = (props) => {
    return <div className={classes.item}>{props.children}</div>;
};
